import { ApolloLink } from "./ApolloLink.js";
export var split = ApolloLink.split;
//# sourceMappingURL=split.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/split.js
// module id = 1496
// module chunks = 4